import React, { useState, useEffect, useRef } from "react";
import Search from "./Search";

export default function DropdownWithSearch({
    options,
    selectedOption,
    handleOptionSelect,
    searchQuery,
    handleSearchInputValueChange,
    handleSearchInputValueClear,
    placeholder
}) {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);

    const toggleExpand = () => {
        setIsDropdownOpen(prev => !prev)
    }

    const handleHeaderEvent = (event) => {
        switch (event.type) {
            case "click":
                toggleExpand();
                break;
            case "keydown":
                if (event.key === "Enter" || event.key === "Escape" || event.key === " ") {
                    toggleExpand();
                }
                break;
            default:
                event();
        }
    };

    function handleSelect(option) {
        handleOptionSelect(option);
        setIsDropdownOpen(false);
    }

    function handleBlur() {
        setIsDropdownOpen(false);
    }

    useEffect(() => {
        function handleClickOutside(event) {
          if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setIsDropdownOpen(false);
          }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
          document.removeEventListener("mousedown", handleClickOutside);
        };
      }, [dropdownRef]);

    return(
        <div className="dropdown-with-search" ref={dropdownRef}>
            <header
                className={"dropdown-with-search__header" + (isDropdownOpen ? " active" : "")}
                tabIndex="0"
                onClick={handleHeaderEvent}
                onKeyDown={handleHeaderEvent}
                aria-haspopup="listbox"
                aria-expanded={isDropdownOpen}
            >
                {selectedOption ? selectedOption.Name : placeholder}
                <span className="arrow-icon"/>
            </header>

            {isDropdownOpen &&
                <div className="dropdown-with-search__content-wrapper">
                    <div className="dropdown-with-search__content" onBlur={handleBlur}>
                        <Search value={searchQuery}
                                placeholder={"Search..."}
                                onChange={handleSearchInputValueChange}
                                clearValue={handleSearchInputValueClear}
                        />
                        <ul className="dropdown-with-search__options-list">
                            {options.map((option) => {
                                return <DropdownItem
                                            key={option.Id}
                                            item={option}
                                            query={searchQuery}
                                            isSelected={selectedOption && selectedOption.Id === option.Id}
                                            handleSelect={handleSelect}
                                        />;
                            })}
                        </ul>
                    </div>
                </div>
            }
        </div>
    )
}

const DropdownItem = ({item, query, isSelected, handleSelect}) => {

    const escapeRegExp = (string) => {
        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }

    const getMarkup = (text) => {
        let queryLowerCase = query.toLowerCase();
        let regExp = new RegExp(`(${escapeRegExp(queryLowerCase)})`, 'gi');
        let parts = text.split(regExp);

        return (
            <span>
                {parts.map((part, i) => part.toLowerCase() === queryLowerCase ?
                    <mark key={i}>{part}</mark> : part
                )}
            </span>
        );
    }

    return (
        <li
            className={"dropdown-with-search__options-list-item" + (isSelected ? " selected" : "")}
            onClick={() => handleSelect(item)}
            onMouseDown={(e) => e.preventDefault()}
            tabIndex="-1"
        >
            <span className="icon"/>
            {getMarkup(item.Name)}
        </li>
    );
};
